/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector, defaultMemoize } from 'reselect';
import { List } from 'immutable';
import isEmpty from 'lodash/isEmpty';
import selectors, {
  getPickupValues,
} from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.selector';
import { getAddressListState } from '@tcp/core/src/components/features/account/AddressBook/container/AddressBook.selectors';
import {
  getUserEmail,
  getUserPhoneNumber,
  getUserName,
  getUserLastName,
  getUserLoggedInState,
  isRememberedUser,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import { getIsAdyenApplePayCheckoutEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getABtestFromState, getSessionStorage } from '@tcp/core/src/utils';
import Progressbar from '@tcp/core/src/components/features/CnC/common/organism/ProgressBar/container/Progressbar.selectors';
import {
  CHECKOUT_REDUCER_KEY,
  SESSIONCONFIG_REDUCER_KEY,
  USER_REDUCER_KEY,
} from '@tcp/core/src/constants/reducer.constants';
import BagPageUtils from '@tcp/core/src/components/features/CnC/BagPage/views/Bagpage.utils';
import { getDynamicLabelValues } from '@tcp/core/src/utils/labels/labelUtilty';
import { parseBoolean } from '../../../../../utils/badge.util';
import { AVAILABILITY } from '../../../../../services/abstractors/CnC/CartItemTile';
import getErrorList from './Errors.selector';
import BAGPAGE_CONSTANTS from '../BagPage.constants';
import COUPON_CONSTANTS from '../../common/organism/CouponAndPromos/Coupon.constants';
import { DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY } from '../../Checkout/Checkout.constants';

export const filterProductsBrand = (arr, searchedValue) => {
  const obj = [];
  const filterArray = arr.filter((value) => {
    return value.getIn(['productInfo', 'itemBrand']) === searchedValue;
  });
  filterArray.forEach((item) => {
    obj.push(item.getIn(['productInfo', 'productPartNumber']));
  });
  return obj;
};

const getTotalItemsCheck = defaultMemoize((state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'totalItems']) || -1;
});

const getTotalItems = defaultMemoize((state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'totalItems']) || 0;
});

const getOrderItems = defaultMemoize((state) => {
  return state?.CartPageReducer?.getIn(['orderDetails', 'orderItems']) || 0;
});

const getInYourBagProducts = createSelector(getOrderItems, (orderItems) => {
  return BagPageUtils.formatBagCarousalData(orderItems);
});

const getorderAccessorieItems = defaultMemoize((state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'orderAccessorieItems']) || 0;
});

const getGiftWrappingTotal = defaultMemoize((state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'giftWrappingTotal']) || 0;
});

const getGiftDiscountTotal = defaultMemoize((state) => {
  return state.CartPageReducer.getIn?.(['orderDetails', 'giftDiscountTotal']) || 0;
});

const getPointsToRedeem = defaultMemoize((state) => {
  return state.CartPageReducer.getIn?.(['orderDetails', 'pointsToRedeem']) || '0';
});

const getBossBopisStore = defaultMemoize((state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'stores']) || 0;
});

const getOrderItemsLocal = (state) => {
  return state.CartPageReducer.get('localCartOrderItems') || [];
};

const getOrderSubTotal = (state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'subTotal']) || 0;
};
const getOrdertTotalPoints = (state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'estimatedRewards']) || 0;
};
const getOrdertTotalRewards = (state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'earnedReward']) || 0;
};

export const getIsPlccCheckoutEnabled = (state) => {
  return state.User.getIn(['personalData', 'isPlccIC']) || false;
};

const getIsBOSSCartAvailable = (state) => {
  return parseBoolean(state.CartPageReducer.getIn(['uiFlags', 'isBOSSCartAvailable']));
};

const getItemIds = (orderItems) => {
  const ids = [];
  orderItems.forEach((item) => {
    const productPartNumber = item.getIn(['productInfo', 'productPartNumber']);
    if (!ids.includes(productPartNumber)) ids.push(productPartNumber);
  });

  return ids.filter(Boolean).join(',');
};

const getItemSkuIds = (orderItems) => {
  const ids = [];
  orderItems.forEach((item) => {
    const itemPartNumber = item.getIn(['productInfo', 'itemPartNumber']);
    if (!ids.includes(itemPartNumber)) ids.push(itemPartNumber);
  });

  return ids.filter(Boolean).join(',');
};

const getCompleteOrderType = (orderItems) => {
  const orderTypes = [];
  if (orderItems?.size > 0) {
    orderItems.forEach((item) => {
      orderTypes.push(item.getIn(['productInfo', 'orderType']));
    });
  }
  return orderTypes;
};

const getStoreAddress = (storeData) => {
  const storeAddress = [];
  let list = [];
  let obj = {};
  if (storeData) {
    if (List.isList(storeData)) {
      storeData.forEach((store) => {
        obj.storeName = store?.get('storeName') || '';
        obj.orderType = store?.get('orderType') || '';
        obj.stLocId = store?.get('stLocId') || '';
        list = store?.get('address') || [];
        list.forEach((item, index) => {
          if (item) {
            obj[index] = item;
          }
        });
      });
    } else if (Array.isArray(storeData)) {
      storeData.forEach((store) => {
        obj.storeName = store?.storeName || '';
        list = store?.address || [];
        const {
          addressLine1 = '',
          addressLine2 = '',
          city = '',
          country = '',
          zipCode = '',
          state = '',
          storePhoneNumber = '',
        } = list;
        const { storeName, orderType, stLocId } = store;
        obj = {
          addressLine1,
          addressLine2,
          city,
          country,
          zipCode,
          phoneNumber: storePhoneNumber,
          state,
          storeName,
          orderType,
          stLocId,
        };
      });
    }
  }
  storeAddress.push(obj);
  return storeAddress;
};

export const getCartProductIds = createSelector(getOrderItems, (cartItems) => {
  return cartItems ? getItemIds(cartItems) : '';
});

export const getCartSkuIds = createSelector(getOrderItems, (cartItems) => {
  return cartItems ? getItemSkuIds(cartItems) : '';
});

const getItemPrice = (item) => {
  return item.getIn(['itemInfo', 'offerPrice']);
};
const getItemPartNumber = (item) => {
  return item.getIn(['productInfo', 'productPartNumber']);
};

const getItemSku = (item) => {
  return item.getIn(['productInfo', 'skuId']);
};

const getItemUPC = (item) => {
  return item.getIn(['productInfo', 'upc'], '');
};

const getItemQuantity = (item) => {
  return item.getIn(['itemInfo', 'quantity']);
};

const getItemBrand = (item) => {
  return item.getIn(['productInfo', 'itemBrand'], '');
};
const fetchItemId = (item) => {
  return item.getIn(['itemInfo', 'itemId'], '');
};

const getItemSize = (item) => {
  return item.getIn(['productInfo', 'size'], '');
};

const getItemColor = (item) => {
  return item.getIn(['productInfo', 'color', 'name'], '');
};

const getItemFit = (item) => {
  return item.getIn(['productInfo', 'fit'], '');
};

const getMostExpensiveItem = (cartItems) => {
  const expensiveItem = cartItems.maxBy((item) => getItemPrice(item));
  return expensiveItem ? expensiveItem.getIn(['productInfo', 'productPartNumber']) : '';
};

const getMostExpensiveItemId = (state) => {
  const cartItems = getOrderItems(state);
  return cartItems ? getMostExpensiveItem(cartItems) : '';
};

const getAfterPayId = (state) => {
  const paymentLists =
    state.Confirmation && state.Confirmation.get('orderConfirmation').paymentsList;
  return paymentLists && paymentLists.find((payment) => payment.afterpay);
};

const getBillingPaymentMethod = (state) => {
  const appliedGiftCards = state.CartPageReducer.getIn(['orderDetails', 'appliedGiftCards']);
  const isGiftCardUsed = appliedGiftCards && appliedGiftCards.size > 0;
  const paymentMethod = state.CartPageReducer.getIn([
    'orderDetails',
    'checkout',
    'billing',
    'paymentMethod',
  ]);
  if (
    paymentMethod !== 'creditCard' &&
    paymentMethod !== 'ADSPlaceCard' &&
    paymentMethod !== '' &&
    isGiftCardUsed
  )
    return 'gc';

  const paymentType = state.CartPageReducer.getIn([
    'orderDetails',
    'checkout',
    'billing',
    'billing',
    'cardType',
  ]);

  const afterPayPayment = getAfterPayId(state);
  if (afterPayPayment && afterPayPayment.afterpay) {
    return isGiftCardUsed ? 'Afterpay, gc' : 'Afterpay';
  }

  return isGiftCardUsed ? `${paymentType}, gc` : paymentType;
};

const getSectionState = (state, sectionId) => state?.singlePageCheckout[sectionId];

export const getSinglePageCheckoutSectionState = () => {
  return createSelector(getSectionState, (sectionSate) => sectionSate);
};

export const getSavedContactDetails = () => {
  let emailAddress = '';
  let phoneNumber = '';
  try {
    let sessionContactDetails = getSessionStorage('CONTACT_FORM');
    if (!isEmpty(sessionContactDetails)) {
      sessionContactDetails = JSON.parse(sessionContactDetails);
      emailAddress =
        sessionContactDetails?.emailAddress === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.email
          ? ''
          : sessionContactDetails?.emailAddress;
      phoneNumber =
        sessionContactDetails?.phoneNumber === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.phone
          ? ''
          : sessionContactDetails?.phoneNumber;
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error in getSavedContactDetails', e);
  }
  return { emailAddress, phoneNumber };
};

const getIsPayPalEnabled = (state) => {
  return parseBoolean(state.CartPageReducer.getIn(['uiFlags', 'isPayPalEnabled']));
};
const getIsCachedDataLoaded = (state) => {
  return parseBoolean(state.CartPageReducer.getIn(['uiFlags', 'isCachedDataLoaded']));
};

const showApplePayDefault = (state) => {
  return parseBoolean(state.CartPageReducer.getIn(['uiFlags', 'showApplePayDefault']));
};

const getIsNonCachedDataLoaded = (state) => {
  return parseBoolean(state.CartPageReducer.getIn(['uiFlags', 'isNonCachedDataLoaded']));
};
const getIsPayPalLibraryRendered = (state) => {
  return parseBoolean(state.CartPageReducer.getIn(['uiFlags', 'isPayPalLibraryRenderDone']));
};

const getIsBagPageLoading = (state) => {
  return parseBoolean(state.CartPageReducer.getIn(['uiFlags', 'bagPageLoadingStatus'])) || false;
};

const getShowMaxItemError = (state) => {
  return parseBoolean(state.CartPageReducer.getIn(['uiFlags', 'maxItemError']));
};
const getShowOOSError = (state) => {
  return parseBoolean(state.CartPageReducer.getIn(['uiFlags', 'OOSError']));
};
const getShowBackPackDeletedError = (state) => {
  return parseBoolean(state.CartPageReducer.getIn(['uiFlags', 'backPackDeletedError']));
};
const getShowVMPError = (state) => {
  return parseBoolean(state.CartPageReducer.getIn(['uiFlags', 'VMPError']));
};
export const getSubmitButtonState = (state) => {
  return parseBoolean(state.CartPageReducer.getIn(['uiFlags', 'setSubmitButtonState']));
};
const getShowMaxItemErrorDisplayed = (state) => {
  return parseBoolean(state.CartPageReducer.getIn(['uiFlags', 'maxItemErrorDisplayed']));
};

const getShowCouponMergeError = (state) => {
  return parseBoolean(state.CartPageReducer.getIn(['uiFlags', 'couponMergeError']));
};

export const getCartTotalAfterPLCCDiscount = (state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'cartTotalAfterPLCCDiscount']);
};

const getAddressIds = (state) => {
  return {
    previousId: state.CartPageReducer.getIn(['uiFlags', 'addressIds', 'previousId']),
    currentId: state.CartPageReducer.getIn(['uiFlags', 'addressIds', 'currentId']),
  };
};

const isNumeric = (value) => {
  return /^-?\d+$/.test(value);
};

export const getConfirmationModalFlag = (state) => {
  return {
    showModal: state.CartPageReducer.get('showConfirmationModal'),
    isEditingItem: state.CartPageReducer.get('isEditingItem'),
    fromApplePayBillingPage: state.CartPageReducer.get('fromApplePayBillingPage'),
  };
};

const getErrorMapping = (state) => {
  return getErrorList(state);
};

const getProductsTypes = createSelector(getOrderItems, (orderItems) => {
  let tcpProducts = [];
  let gymProducts = [];
  let snjProducts = [];
  let pjpProducts = [];
  if (orderItems) {
    tcpProducts = filterProductsBrand(orderItems, 'TCP');
    gymProducts = filterProductsBrand(orderItems, 'GYM');
    snjProducts = filterProductsBrand(orderItems, 'SNJ');
    pjpProducts = filterProductsBrand(orderItems, 'PJP');
  }
  return {
    tcpProducts,
    gymProducts,
    snjProducts,
    pjpProducts,
  };
});

const getNeedHelpContent = () => {
  const { referred } = getDynamicLabelValues('global.addedToBagModal');
  return referred && referred.length && referred.find((label) => label.name === 'NEED_HELP_DATA');
};

const getPlaceCashContent = () => {
  const { referred } = getDynamicLabelValues('global.addedToBagModal');
  return referred && referred.length && referred.find((label) => label.name === 'PLACE_CASH_DATA');
};

const getGiftServicesContentInfo = (brand) => {
  const { referred } = getDynamicLabelValues('checkout.shipping');
  return (
    referred &&
    referred.length &&
    referred.find((label) => label.name === `GiftServicesDetails${brand}Modal`)
  );
};

const getFilteredItems = (state, filter) => {
  const orderItems = getOrderItems(state);
  return (
    (orderItems &&
      orderItems.size &&
      orderItems.filter((item) => filter(item.getIn(['miscInfo', 'availability'])))) ||
    List()
  );
};

const getOnlineOnlyItems = (state, onlineOnly) => {
  const orderItems = getOrderItems(state);
  return (
    (orderItems &&
      orderItems.size &&
      orderItems.filter((item) => onlineOnly(item.getIn(['miscInfo', 'isOnlineOnly'])))) ||
    List()
  );
};

const hasGiftCardItem = (state) => {
  const orderItems = getOrderItems(state);

  if (!orderItems || !orderItems.size) {
    return false;
  }

  return orderItems.some((item) => item.getIn(['productInfo', 'isGiftCard']) === true);
};

const getOfflineItems = (state, onlineOnly) => {
  const orderItems = getOrderItems(state);
  return (
    (orderItems &&
      orderItems.size &&
      orderItems.filter((item) => onlineOnly(item.getIn(['miscInfo', 'online'])))) ||
    List()
  );
};

const getUnqualifiedItems = createSelector(
  [
    (state) => getFilteredItems(state, (type) => type !== AVAILABILITY.OK),
    (state) => getOfflineItems(state, (type) => type === false),
  ],
  (filteredItems, offlineItems) => {
    return [...filteredItems, ...offlineItems];
  }
);
const getUnqualifiedCount = (state) => getUnqualifiedItems(state).length;
const getUnqualifiedItemsIds = (state) =>
  getUnqualifiedItems(state).map((item) => item.getIn(['itemInfo', 'itemId']));

const getUnavailableCount = (state) =>
  getFilteredItems(state, (type) => type === AVAILABILITY.UNAVAILABLE).size;

const getOfflineProductCount = (state) => getOfflineItems(state, (type) => type === false);
const getOnlyOnlineProduct = (state) => getOnlineOnlyItems(state, (type) => type === true);
const getCurrentOrderId = (state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'orderId']) || 0;
};

const getOOSCount = (state) =>
  getFilteredItems(state, (type) => type === AVAILABILITY.SOLDOUT).size;

const returnCurrentCurrency = (currency) => {
  return currency === 'USD' || currency === 'CAD' ? '$' : currency;
};
const getCurrentCurrency = (state) => {
  const currency = state.session && state.session.siteDetails.currency;
  return currency ? returnCurrentCurrency(currency) : '$';
};

const getCartStores = createSelector(getBossBopisStore, (storeData) => {
  return getStoreAddress(storeData);
});

const getCartStoresToJs = createSelector(
  getCartStores,
  (store) => store && JSON.parse(JSON.stringify(store))
);

const getsflItemsList = (state) => {
  return state.CartPageReducer.get('sfl');
};
const getSflListId = (state) => {
  return state.CartPageReducer.get('sflId');
};
const getCartSflMerged = (state) => {
  return state.CartPageReducer.get('cartSflMerged');
};

/** @function checkoutIfItemIsUnqualified to check if item is Unavailable
 * @param {object} state
 * @param {string|number} itemId
 */
const checkoutIfItemIsUnqualified = (state, itemId) => {
  const items = getOrderItems(state);
  const indexValue = items.findIndex(
    (item) =>
      item.getIn(['itemInfo', 'itemId']) === itemId.toString() &&
      item.getIn(['miscInfo', 'availability']) !== AVAILABILITY.OK
  );
  return indexValue >= 0;
};

/** @function getCurrentDeleteSelectedItemInfo to get confirmation modal info
 * @param {object} state
 */
export const getCurrentDeleteSelectedItemInfo = (state) => {
  return state.CartPageReducer.get('openItemDeleteConfirmationModalInfo');
};

const getZipForTaxEstimation = (state) => {
  return state.CartPageReducer.get('zipForTaxEstimation');
};

export const isFromEstimatedTaxFormFlag = (state) => {
  return !!state.CartPageReducer.get('isFromEstimatedTaxForm');
};
const getCalculatedEstimatedTax = (state) => {
  return state.CartPageReducer.get('calculatedEstimatedTax');
};

const getIsTaxCalculated = (state) => {
  return state.CartPageReducer.get('isTaxCalculated');
};

const getIsCouponCalculateTax = (state) => {
  return state.CartPageReducer.get('couponCalculateTax');
};

const getDefaultSocialProofBanner = (state) => {
  return state.CartPageReducer.get('defaultSocialProofBanner');
};

const getPlccLoginModalState = (state) => {
  return state.CartPageReducer.get('plccLoginModalState');
};

const getIsTotalCalculated = (state) => {
  return state.CartPageReducer.get('isTotalCalculated');
};

const getCartPageReducerState = (state) => {
  return state.CartPageReducer;
};

const getPayPalWebViewStatus = (state) => {
  return state.CartPageReducer.getIn(['uiFlags', 'isPayPalWebViewEnable']) || false;
};

const isPayPalButtonRenderDone = (state) => {
  return state.CartPageReducer.getIn(['uiFlags', 'isPayPalRenderDone']) || false;
};

const getIsPayPalModalActionOOS = (state) => {
  return state.CartPageReducer.getIn(['uiFlags', 'isPayPalModalActionOOS']) || false;
};

const getIsApplePayModalActionOOS = (state) => {
  return state.CartPageReducer.getIn(['uiFlags', 'isApplePayModalActionOOS']) || false;
};

const isBagLoaded = (state) => {
  return state.CartPageReducer.getIn(['loaded']);
};
const getBagStickyHeaderInterval = (state) => {
  return (
    parseInt(state.session.siteDetails.BAG_CONDENSE_HEADER_INTERVAL, 10) ||
    BAGPAGE_CONSTANTS.BAG_PAGE_STICKY_HEADER_INTERVAL
  );
};

const getIsPayPalHidden = (state) => {
  return state.CartPageReducer.getIn(['paypalBtnHidden']);
};

const isBagLoading = createSelector(getCartPageReducerState, (cartPageReducer) =>
  cartPageReducer.getIn(['bagLoading'])
);

const isNonCacheBagLoading = createSelector(getCartPageReducerState, (cartPageReducer) =>
  cartPageReducer.getIn(['nonCacheBagLoading'])
);

const getProductBrand = (state, itemId) => {
  const cartItems = getOrderItems(state);
  const product = cartItems.find((item) => fetchItemId(item) === itemId);
  return getItemBrand(product);
};

const isBagRouting = (state) => {
  return state.CartPageReducer.get('isRouting');
};

const getCartLoadedState = (state) => {
  return state.CartPageReducer.get('loaded');
};

const getIfEmailSignUpDone = (state) => {
  return {
    emailSignUpTCP: state.CartPageReducer.getIn(['orderDetails', 'emailSignUpTCP']),
    emailSignUpGYM: state.CartPageReducer.getIn(['orderDetails', 'emailSignUpGYM']),
  };
};

const getOptimiseAddProductOrderDetailsEnabled = (state) => {
  return parseInt(state.session.siteDetails.OPTIMISE_ADDPRODUCT_ORDERDETAILS_ENABLED, 10) || 0;
};

export const getCartModuleXList = (state) => {
  return state.CartPageReducer.get('moduleXContent');
};

const getCouponCachingTTL = (state) => {
  return +(
    (state.session && state.session.siteDetails && state.session.siteDetails.COUPON_CACHING_TTL) ||
    COUPON_CONSTANTS.GET_COUPON_LIST_TTL
  );
};

export const isPersistEddGlobalEnabled = (state) => {
  return (
    parseBoolean(
      state.session &&
        state.session.siteDetails &&
        parseBoolean(state.session.siteDetails.IS_PERSISTEDD_GLOBAL_ENABLED)
    ) || false
  );
};

export const isPersistEddCartPageEnabled = (state) => {
  return (
    parseBoolean(
      state.session &&
        state.session.siteDetails &&
        parseBoolean(state.session.siteDetails.IS_PERSISTEDD_CARTPAGE_ENABLED)
    ) || false
  );
};

export const getBossStatus = (state) => {
  const list = getOrderItems(state);
  const orderTypeList = getCompleteOrderType(list);
  if (orderTypeList?.length > 0) {
    return (
      orderTypeList.every((item) => {
        return item === 'BOSS';
      }) || false
    );
  }
  return false;
};

export const getBopisStatus = (state) => {
  const list = getOrderItems(state);
  const orderTypeList = getCompleteOrderType(list);
  return orderTypeList.every((item) => item === 'BOPIS') || false;
};

export const getECOMStatus = (state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'isECOM']);
};

export const isMixedPaymentWithPaypal = (state) => {
  return state.CartPageReducer.get('isMixedPaymentWithPaypal');
};

export const isECOMStatus = (state) => {
  const list = state.CartPageReducer.getIn(['orderDetails', 'orderItems']);
  const orderTypeList = getCompleteOrderType(list);
  return (
    orderTypeList.every((item) => item === null || item === 'ECOM' || item === 'PURE_ECOM') || false
  );
};

export const isPickuOrderStatus = (state) => {
  const list = state.CartPageReducer.getIn(['orderDetails', 'orderItems']);
  const orderTypeList = getCompleteOrderType(list);
  if (orderTypeList.includes('BOPIS') || orderTypeList.includes('BOSS')) {
    return true;
  }
  return false;
};

const isEcom = (orderTypeList) => {
  return (
    orderTypeList?.includes('ECOM') ||
    orderTypeList?.includes('PURE_ECOM') ||
    orderTypeList?.includes(null)
  );
};

export const isMixedOrderStatus = (state) => {
  const list = state.CartPageReducer.getIn(['orderDetails', 'orderItems']);
  const orderTypeList = getCompleteOrderType(list);
  if (
    isEcom(orderTypeList) &&
    (orderTypeList.includes('BOPIS') || orderTypeList.includes('BOSS'))
  ) {
    return true;
  }
  return false;
};
const getShippingAddressState = (state) => {
  return (
    state &&
    state.CartPageReducer.getIn(['orderDetails', 'checkout', 'shipping', 'address', 'state'])
  );
};

const getShippingMethod = (state) => {
  return (
    state && state.CartPageReducer.getIn(['orderDetails', 'checkout', 'shipping', 'method', 'code'])
  );
};

const getShippingAddressZip = (state) => {
  return (
    state &&
    state.CartPageReducer.getIn(['orderDetails', 'checkout', 'shipping', 'address', 'zipCode'])
  );
};
const getShippingAddressEmail = (state) => {
  return (
    state && state.CartPageReducer.getIn(['orderDetails', 'checkout', 'shipping', 'emailAddress'])
  );
};

const getShippingMethodID = (state) => {
  return (
    state &&
    state.CartPageReducer.getIn([
      'orderDetails',
      'checkout',
      'shipping',
      'method',
      'shippingMethodId',
    ])
  );
};

const getAddressLines = (addressField1, addressField2) => {
  const addressLines = [];
  if (addressField1) addressLines.push(addressField1);
  if (addressField2) addressLines.push(addressField2);
  return addressLines;
};
const getAvoidFewStates = (state) => {
  return state === 'AK' || state === 'PR' || state === 'HI';
};

const getCompleteShippingAddress = (state) => {
  if (!state) return {};
  const administrativeArea = state.CartPageReducer.getIn([
    'orderDetails',
    'checkout',
    'shipping',
    'address',
    'state',
  ]);

  const isAdyenCheckoutEnabled = getIsAdyenApplePayCheckoutEnabled(state);

  if (!isAdyenCheckoutEnabled && getAvoidFewStates(administrativeArea)) return {};

  const givenName = state.CartPageReducer.getIn([
    'orderDetails',
    'checkout',
    'shipping',
    'address',
    'firstName',
  ]);
  const familyName = state.CartPageReducer.getIn([
    'orderDetails',
    'checkout',
    'shipping',
    'address',
    'lastName',
  ]);
  const addressField1 = state.CartPageReducer.getIn([
    'orderDetails',
    'checkout',
    'shipping',
    'address',
    'addressLine1',
  ]);
  const addressField2 = state.CartPageReducer.getIn([
    'orderDetails',
    'checkout',
    'shipping',
    'address',
    'addressLine2',
  ]);
  const locality = state.CartPageReducer.getIn([
    'orderDetails',
    'checkout',
    'shipping',
    'address',
    'city',
  ]);
  const countryCode = state.CartPageReducer.getIn([
    'orderDetails',
    'checkout',
    'shipping',
    'address',
    'country',
  ]);

  const postalCode = state.CartPageReducer.getIn([
    'orderDetails',
    'checkout',
    'shipping',
    'address',
    'zipCode',
  ]);
  const phoneNumber = state.CartPageReducer.getIn([
    'orderDetails',
    'checkout',
    'shipping',
    'phoneNumber',
  ]);

  const addressId = state.CartPageReducer.getIn([
    'orderDetails',
    'checkout',
    'shipping',
    'address',
    'addressId',
  ]);

  const phoneCountryCode = state.CartPageReducer.getIn([
    'orderDetails',
    'checkout',
    'shipping',
    'address',
    'phoneCountryCode',
  ]);

  const validationCode = state.CartPageReducer.getIn([
    'orderDetails',
    'checkout',
    'shipping',
    'address',
    'validationCode',
  ]);

  return {
    givenName: givenName || getUserName(state) || '',
    familyName: familyName || getUserLastName(state) || '',
    addressLines: getAddressLines(addressField1, addressField2),
    locality: locality || '',
    countryCode: countryCode || '',
    administrativeArea: administrativeArea || '',
    postalCode: postalCode || '',
    phoneNumber: phoneNumber || getUserPhoneNumber(state) || '',
    addressId: addressId || '',
    phoneCountryCode: phoneCountryCode || '',
    c_validationCode: validationCode || '',
  };
};

const getApplePayShipmentAddress = (defaultAddress = {}, emailAddress) => {
  const {
    address1 = '',
    address2 = '',
    stateCode = '',
    postalCode = '',
    countryCode = '',
    city = '',
    firstName = '',
    lastName = '',
    phone = '',
    // eslint-disable-next-line camelcase
    c_emailId,
    addressId,
    // eslint-disable-next-line camelcase
    c_validationCode,
  } = defaultAddress;
  const addressLine1 = address1 || '';
  const addressLine2 = address2 || '';
  if (getAvoidFewStates(stateCode)) return {};
  return {
    addressLines: getAddressLines(addressLine1, addressLine2),
    countryCode: countryCode || '',
    administrativeArea: stateCode || '',
    postalCode: postalCode || '',
    locality: city || '',
    familyName: lastName === null ? '' : lastName,
    givenName: firstName === null ? '' : firstName,
    phoneNumber: phone === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.phone ? '' : phone,
    emailAddress:
      // eslint-disable-next-line camelcase
      c_emailId === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.email ? '' : c_emailId || emailAddress,
    addressId: addressId || '',
    // eslint-disable-next-line camelcase
    c_validationCode: c_validationCode || '',
  };
};

export const getOrderType = (state) => {
  const list = getOrderItems(state);
  const orderTypeList = getCompleteOrderType(list);
  const pureBoss = orderTypeList.every((item) => item === 'BOSS') ? 'PURE_BOSS' : 'ECOM_MIX';
  const pureBopis = orderTypeList.every((item) => item === 'BOPIS') ? 'PURE_BOPIS' : pureBoss;
  return orderTypeList.every((item) => item === null || item === 'ECOM' || item === 'PURE_ECOM')
    ? 'PURE_ECOM'
    : pureBopis;
};

export const getIsMultistoreOrder = (state) => {
  const orderItems = getOrderItems(state);

  // Ensure orderItems is defined and is an array or Immutable List
  if (!orderItems || typeof orderItems.map !== 'function') {
    return false;
  }

  const storeIds = orderItems.map((item) => item.getIn(['miscInfo', 'storeId']));
  const uniqueStoreIds = new Set(storeIds);

  // Clarify logic with descriptive variable
  return uniqueStoreIds.size !== 1;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
const getCompleteShippingContactForBossBopis = (state) => {
  if (!state) return {};
  const item = state.CartPageReducer.getIn(['orderDetails', 'stores']);
  const names = state.CartPageReducer.getIn(['orderDetails', 'shipments']);
  const orderAddress = {};
  if (item) {
    const storeAddress = [];
    let list = [];
    let obj = {};
    if (List.isList(item)) {
      item.forEach((store) => {
        obj.storeName = store?.get('storeName') || '';
        list = store?.get('address') || [];
        list.forEach((storeItem, index) => {
          if (storeItem) {
            obj[index] = storeItem;
          }
        });
      });
    } else if (Array.isArray(item)) {
      item.forEach((store) => {
        list = store?.address || [];
        obj = {
          addressLine1: list.addressLine1,
          addressLine2: list.addressLine2,
          city: list.city,
          country: list.country,
          zipCode: list.zipCode,
          state: list.state || '',
          storeName: store.storeName,
        };
      });
    }
    storeAddress.push(obj);
    const {
      addressLine1 = '',
      addressLine2 = '',
      city = '',
      country = '',
      zipCode = '',
      storeName = '',
    } = storeAddress?.[0];
    orderAddress.addressField1 = addressLine1;
    orderAddress.addressField2 = addressLine2;
    orderAddress.locality = city;
    orderAddress.countryCode = country;
    orderAddress.postalCode = zipCode;
    orderAddress.administrativeArea = storeAddress?.[0]?.state;
    orderAddress.storeName = storeName;
  }
  const nameObj = {};
  if (List.isList(names)) {
    names.forEach((newItem) => {
      const shipmentMethodId = newItem.getIn(['shippingMethod', 'id']);
      if (shipmentMethodId === 'BOPIS') {
        nameObj.firstName = newItem.getIn(['shippingAddress', 'firstName']);
        nameObj.lastName = newItem.getIn(['shippingAddress', 'lastName']);
      }
    });
  }
  const contactPhoneNumber = getSavedContactDetails()?.phoneNumber;
  orderAddress.givenName =
    getPickupValues(state)?.firstName || nameObj?.firstName || getUserName(state) || '';
  orderAddress.familyName =
    getPickupValues(state)?.lastName || nameObj?.lastName || getUserLastName(state) || '';
  orderAddress.phoneNumber = isNumeric(contactPhoneNumber)
    ? contactPhoneNumber
    : getUserPhoneNumber(state) || getPickupValues(state)?.phoneNumber || '';

  const {
    givenName = '',
    familyName = '',
    addressField1 = '',
    addressField2 = '',
    locality = '',
    countryCode = '',
    postalCode = '',
    phoneNumber = '',
    administrativeArea = '',
  } = orderAddress || {};

  if (!countryCode) {
    console.error('Adyen Apple Pay missing country code in bagpage selector');
  }
  return {
    givenName,
    familyName,
    addressLines: getAddressLines(addressField1, addressField2),
    locality,
    countryCode,
    administrativeArea,
    postalCode,
    phoneNumber,
  };
};

const getShippingContactForApplePay = (state) => {
  const cartAddress =
    getOrderType(state) === 'PURE_ECOM' || getOrderType(state) === 'ECOM_MIX'
      ? getCompleteShippingAddress(state)
      : getCompleteShippingContactForBossBopis(state);
  const emailAddress =
    getOrderType(state) === 'PURE_ECOM' || getOrderType(state) === 'ECOM_MIX'
      ? getShippingAddressEmail(state) || getUserEmail(state) || ''
      : getSavedContactDetails()?.emailAddress || getUserEmail(state) || '';

  cartAddress.emailAddress = emailAddress;
  if (cartAddress && (cartAddress.postalCode || cartAddress.administrativeArea)) {
    return cartAddress;
  }
  const shippingAddressBook = selectors.getShippingAddressList(state);
  const addressBook = getAddressListState(state);
  const defaultAddress =
    (shippingAddressBook &&
      shippingAddressBook.find((node) => node && node.preferred === 'true')) ||
    (addressBook && addressBook.find((node) => node && node.preferred === 'true')) ||
    {};
  return getApplePayShipmentAddress(defaultAddress, emailAddress);
};
const getShippingModeID = (state) => {
  return state && state.CartPageReducer.getIn(['orderDetails', 'shipModeId']);
};

const getCouponMap = (state) => {
  return (state && state.CartPageReducer.getIn(['orderDetails', 'c_couponMap'])) || '';
};

const getIsGettingPaypalSettings = (state) => {
  return parseBoolean(state.CartPageReducer.getIn(['uiFlags', 'isGettingPaypalSettings']));
};

const getOpenExpressAfterPayPopup = (state) => {
  return parseBoolean(state.CartPageReducer.getIn(['uiFlags', 'openExpressAfterPayPopup']));
};

export const getLoyaltyPointsRequestPayload = (state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'loyaltyPointsRequestPayload']);
};

export const getEstimatedTaxFromDefaultShipping = (state) => {
  return !!state.CartPageReducer.get('isEstimatedTaxFromDefaultShipping');
};
export const isNonCacheDataLoaded = (state) => {
  return state.CartPageReducer.get('isNonCacheDataLoaded');
};
const getIsPlccICAddressModalOpen = (state) => {
  return !!state.CartPageReducer.get('isPlccICAddressModalOpen');
};
const getIsPlccICPickupModalOpen = (state) => {
  return !!state.CartPageReducer.get('isPlccICPickupModalOpen');
};
export const getIsPlccShippingAddressUpdate = (state) => {
  return state.CartPageReducer.get('isPlccShippingAddressUpdate');
};

export const getRawCartItems = (state) => {
  const lpPayload = getLoyaltyPointsRequestPayload(state);
  return (lpPayload && JSON.parse(JSON.stringify(lpPayload.get('loyaltyOrderItems')))) || [];
};

const getRemoveCouponError = (state) => {
  return state.CartPageReducer.get('removeCouponApiError');
};

const getRemoveCouponSuccess = (state) => {
  return state.CartPageReducer.get('removeCouponApiSuccess');
};

export const getCartLoyaltyPointsCount = (state) => {
  const lpPayload = getRawCartItems(state);
  let lpCount = 0;
  lpPayload.forEach((lp) => {
    lpCount += lp.itemPoints;
  });
  return lpCount;
};

export const getCartBackAbTest = ({ AbTest }) => {
  const AbTests = getABtestFromState(AbTest);
  return AbTests && AbTests.isCartBackAbTestEnabled;
};

export const getSignInBannerAbTest = ({ AbTest }) => {
  const AbTests = getABtestFromState(AbTest);
  return AbTests && AbTests.isSignInBannerAbTestEnabled;
};

const getCartSupressOnBagUpdate = (state) => {
  return state.CartPageReducer.get('isCartSupressOnBagUpdate');
};

const getIsPlaceCashEnabled = (state) => {
  const amt = Progressbar.getAmountToNextReward(state);
  let isPlaceCashEnabled = false;
  const abtest = getABtestFromState(state.AbTest).PlaceCash;
  if (abtest && abtest.isPlaceCashEnabled && amt <= abtest.NextPlaceCash) isPlaceCashEnabled = true;
  return isPlaceCashEnabled;
};

const getIsPlaceRewardEnabled = (state) => {
  const amt = Progressbar.getPointsToNextReward(state);
  let isPlaceRewardEnabled = false;
  const abtest = getABtestFromState(state.AbTest).PlaceReward;
  if (abtest && abtest.isPlaceRewardEnabled && amt <= abtest.NextPlaceReward)
    isPlaceRewardEnabled = true;
  return isPlaceRewardEnabled;
};

const getTaxIdentifier = (state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'taxIdentifierAttribute']);
};
const getOrderPriceAdjustments = (state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'orderPriceAdjustments']);
};

export const getToastRedesign = (state) => {
  // Kill Switch Handling for ENABLE_TOAST_REDESIGN
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.ENABLE_TOAST_REDESIGN)
  );
};
const buttonLoaderState = (state) => {
  return state.CartPageReducer.get('buttonLoader');
};

export const getCartItemsSelector = createSelector(
  [getOrderItems, getCurrentCurrency],
  (items, currency) => {
    const cartItems = [];

    if (items) {
      items.forEach((item) => {
        const value = getItemPrice(item);
        const sku = getItemUPC(item);
        const pid = getItemPartNumber(item);
        const quantity = getItemQuantity(item);
        cartItems.push({
          value,
          sku,
          pid,
          quantity,
          currency,
        });
      });
    }
    return cartItems;
  }
);

export const getShareCartError = (state) => {
  return state.CartPageReducer?.get('saveShareCartErr');
};

export const getFetchShareCartError = (state) => {
  return state.CartPageReducer?.get('fetchShareCartErr');
};

export const getProductIdWithQuantity = createSelector(getOrderItems, (cartItems) => {
  if (cartItems) {
    return cartItems.reduce((acc, item) => {
      acc[getItemPartNumber(item)] = {
        quantity: getItemQuantity(item),
        size: getItemSize(item),
        color: getItemColor(item),
        fit: getItemFit(item),
      };
      return acc;
    }, {});
  }
  return {};
});

const getCouponDescriptonFromPriceAdjustments = createSelector(
  [getOrderPriceAdjustments, getOrderItems],
  (orderPriceAdjustments, orderItems) => {
    const cartItems = JSON.parse(JSON.stringify(orderItems)) || [];
    const itemPriceAdjustments = cartItems && cartItems[0]?.miscInfo?.priceAdjustments;
    const priceAdjustments =
      orderPriceAdjustments !== null &&
      orderPriceAdjustments !== undefined &&
      orderPriceAdjustments.length > 0
        ? orderPriceAdjustments
        : itemPriceAdjustments;
    return Array.isArray(priceAdjustments)
      ? priceAdjustments.reduce((obj, item) => {
          return {
            ...obj,
            [item.couponCode]: item.itemText,
          };
        }, {})
      : {};
  }
);

const getPlccPromoEligiblity = (state) => {
  const personalData = state[USER_REDUCER_KEY].get('personalData');
  return personalData && personalData.get('plccPromoEligible');
};

const getSiteDetails = (state) => {
  return (state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].siteDetails) || {};
};

const getIsPayPalPaymentSelected = (state) => {
  const checkoutState = state[CHECKOUT_REDUCER_KEY];
  const cartPaymentMethod = state.CartPageReducer.getIn([
    'orderDetails',
    'checkout',
    'billing',
    'paymentMethod',
  ]);
  let billing;
  billing = checkoutState?.getIn(['values', 'billing']);
  if (billing.size === 0) {
    billing = {};
  }
  const { paymentMethod } = billing;
  return paymentMethod === 'PAYPAL' || cartPaymentMethod === 'PAYPAL';
};

export const getFreeShippingType = createSelector(
  [
    getBillingPaymentMethod,
    getPlccPromoEligiblity,
    getSiteDetails,
    getUserLoggedInState,
    isRememberedUser,
    getIsPayPalPaymentSelected,
  ],
  (paymentMethod, plccPromoEligible, siteDetails, isLoggedIn, isRemembered, isPaypalSelected) => {
    const placeCard = 'PLACE CARD';
    let freeShippingPromo;
    let payMethod = paymentMethod;
    if (isPaypalSelected) {
      payMethod = 'PAYPAL';
    }
    const freeShippingThershold = parseInt(siteDetails?.FREE_SHIPPING_THERSHOLD, 10) || 0;
    const registerUserShippingThershold =
      parseInt(siteDetails?.REGISTER_USER_FREE_SHIPPING_THERSHOLD, 10) || 0;
    const plccFreeShippingEnabled = parseBoolean(siteDetails?.PLCC_FREE_SHIPPING_ENABLED);
    const isADSPaymentPresent = payMethod === placeCard || payMethod?.includes(placeCard);
    if (isLoggedIn || isRemembered) {
      freeShippingPromo = 'genric';
      if (registerUserShippingThershold < freeShippingThershold) {
        freeShippingPromo = 'mpr';
      }
      if (
        plccFreeShippingEnabled &&
        ((plccPromoEligible && (!payMethod || isADSPaymentPresent)) || isADSPaymentPresent)
      ) {
        freeShippingPromo = 'plcc';
      }
    } else if (isADSPaymentPresent && plccFreeShippingEnabled) {
      freeShippingPromo = 'plcc';
    } else {
      freeShippingPromo = 'genric';
    }
    return freeShippingPromo;
  }
);

export const getFreeShippingThresholdValue = createSelector(
  [
    getBillingPaymentMethod,
    getPlccPromoEligiblity,
    getSiteDetails,
    getUserLoggedInState,
    isRememberedUser,
    getIsPayPalPaymentSelected,
  ],
  (paymentMethod, plccPromoEligible, siteDetails, isLoggedIn, isRemembered, isPaypalSelected) => {
    const plccFreeShippingThershold = parseInt(siteDetails?.PLCC_FREE_SHIPPING_THERSHOLD, 10) || 0;
    const freeShippingThershold = parseInt(siteDetails?.FREE_SHIPPING_THERSHOLD, 10) || 0;
    const registerUserShippingThershold =
      parseInt(siteDetails?.REGISTER_USER_FREE_SHIPPING_THERSHOLD, 10) || 0;
    const plccFreeShippingEnabled = parseBoolean(siteDetails?.PLCC_FREE_SHIPPING_ENABLED);
    const placeCard = 'PLACE CARD';
    let thresholdValue = 20;
    let payMethod = paymentMethod;
    if (isPaypalSelected) {
      payMethod = 'PAYPAL';
    }
    const isADSPaymentPresent = payMethod === placeCard || payMethod?.includes(placeCard);
    if (isLoggedIn || isRemembered) {
      thresholdValue = registerUserShippingThershold;
      if (
        plccFreeShippingEnabled &&
        ((plccPromoEligible && (!payMethod || isADSPaymentPresent)) || isADSPaymentPresent)
      ) {
        thresholdValue = plccFreeShippingThershold;
      }
    } else if (isADSPaymentPresent && plccFreeShippingEnabled) {
      thresholdValue = plccFreeShippingThershold;
    } else {
      thresholdValue = freeShippingThershold;
    }
    return thresholdValue;
  }
);

export const getIsFreeShippingCouponApplied = (state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'isFreeShippingCouponApplied']) || false;
};

export const getIsQuickAddModalOpen = (state) => {
  return state.CartPageReducer.get('isQuickAddModalOpen');
};

export const getQuickAddRecommendationType = (state) => {
  return state.CartPageReducer.get('quickAddRecommendationsType');
};

export const getHasSflCallCompleted = (state) => {
  return state.CartPageReducer.get('hasSflCallCompleted');
};

export const getAdyenSessionData = (state) => {
  return state.CartPageReducer.get('adyenSessionData');
};

export const getAdyenSetupData = (state) => {
  return state.CartPageReducer.get('adyenSetupData');
};

export const getAddToBagCallMade = (state) => {
  return state.CartPageReducer.get('isAddToBagCallMade');
};

export default {
  getCartModuleXList,
  getTotalItems,
  getTotalItemsCheck,
  getOrderItems,
  getorderAccessorieItems,
  getGiftWrappingTotal,
  getGiftDiscountTotal,
  getPointsToRedeem,
  getOrderItemsLocal,
  getProductsTypes,
  getNeedHelpContent,
  getPlaceCashContent,
  getUnqualifiedCount,
  getUnqualifiedItemsIds,
  getUnqualifiedItems,
  getUnavailableCount,
  getOOSCount,
  getOnlyOnlineProduct,
  hasGiftCardItem,
  getOfflineProductCount,
  getConfirmationModalFlag,
  getFilteredItems,
  getCurrentOrderId,
  getErrorMapping,
  getGiftServicesContentInfo,
  getCurrentCurrency,
  getCartStores,
  isBagLoaded,
  getCartStoresToJs,
  getsflItemsList,
  getSflListId,
  getCartSflMerged,
  checkoutIfItemIsUnqualified,
  getCurrentDeleteSelectedItemInfo,
  getIsPayPalEnabled,
  getIsCachedDataLoaded,
  getIsNonCachedDataLoaded,
  getBagStickyHeaderInterval,
  getPayPalWebViewStatus,
  isPayPalButtonRenderDone,
  getIsPayPalHidden,
  getIsPayPalLibraryRendered,
  isBagLoading,
  isNonCacheBagLoading,
  getStoreAddress,
  getCartLoadedState,
  isBagRouting,
  getIfEmailSignUpDone,
  getOrderSubTotal,
  getBillingPaymentMethod,
  getOptimiseAddProductOrderDetailsEnabled,
  getCartProductIds,
  getMostExpensiveItemId,
  getCouponCachingTTL,
  getBossStatus,
  getBopisStatus,
  getAddressIds,
  getIsPayPalModalActionOOS,
  getIsApplePayModalActionOOS,
  getShippingAddressState,
  getShippingMethodID,
  getShippingAddressZip,
  getCompleteShippingAddress,
  getShippingAddressEmail,
  getShippingContactForApplePay,
  getShippingModeID,
  getIsGettingPaypalSettings,
  getItemPartNumber,
  getItemSku,
  getItemQuantity,
  getItemPrice,
  getItemUPC,
  getOrderType,
  getCartBackAbTest,
  getSignInBannerAbTest,
  getCartSupressOnBagUpdate,
  getIsPlaceCashEnabled,
  getShowMaxItemErrorDisplayed,
  getIsPlaceRewardEnabled,
  getShowMaxItemError,
  getShowOOSError,
  getShowVMPError,
  getShowCouponMergeError,
  getTaxIdentifier,
  getProductBrand,
  getIsBagPageLoading,
  getBossBopisStore,
  getCompleteShippingContactForBossBopis,
  getOrderPriceAdjustments,
  getCouponDescriptonFromPriceAdjustments,
  getZipForTaxEstimation,
  getCalculatedEstimatedTax,
  getToastRedesign,
  getIsTaxCalculated,
  getIsPlccICAddressModalOpen,
  isNonCacheDataLoaded,
  getIsPlccShippingAddressUpdate,
  getIsTotalCalculated,
  getOrdertTotalRewards,
  getOrdertTotalPoints,
  buttonLoaderState,
  getShowBackPackDeletedError,
  getIsPlccICPickupModalOpen,
  getIsCouponCalculateTax,
  getDefaultSocialProofBanner,
  showApplePayDefault,
  getOpenExpressAfterPayPopup,
  getShippingMethod,
  getCouponMap,
  getIsBOSSCartAvailable,
  getInYourBagProducts,
  getRemoveCouponError,
  getRemoveCouponSuccess,
  getPlccLoginModalState,
  getApplePayShipmentAddress,
  getPlccPromoEligiblity,
  getIsMultistoreOrder,
  getAddToBagCallMade,
  getCartSkuIds,
};
